import React from 'react'
import { FormattedMessage } from 'react-intl'

type Props = {
  heading: React.ReactNode
  children: React.ReactNode
}

export default function Error({ heading, children }: Props) {
  return (
    <div className="relative flex w-full flex-col self-stretch lg:pb-96">
      <div className="mx-auto my-auto max-w-576 text-center">
        <h1 className="type-med-minus-fat mb-20 text-secondary-red">
          {heading}
        </h1>
        {children}
      </div>
      <a
        href="https://help.lifesum.com"
        className={`
        bottom-0 left-1/2 mb-8
        mt-auto transform
        rounded-full border-1 border-grey-lightest
        px-30 pb-11
        pt-12 text-center text-Type transition type-14-demibold-caps hover:bg-Bg hover:text-blue-dark hover:shadow-elevated
        lg:absolute lg:mb-32 lg:mt-0 lg:-translate-x-1/2 lg:px-40
      `}
      >
        <FormattedMessage
          id="gympass_contact_support"
          defaultMessage="Contact support"
        />
      </a>
    </div>
  )
}
